import React from "react";
import {
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
} from "mdbreact";
import { useEffect, useMemo, useRef, useState } from "react";
import { setCompanyUsers, setProjects, setSidebarStatus } from "actions/user";
import { IFC_Url, url } from "api";
import { liveManifestUrl, legacyManifestUrl } from "helpers/liveManifest";
import { getCompressedJsonFile } from "api/files/getJsonFile";
import { getProjects } from "api/projects/getProjects";
import TreeViewerItem from "components/TreeViewerItem";
import Loading from "components/ui-components/loading";
import { generateId } from "helpers/id";
import { Maybe } from "helpers/maybeFunctor";
import addNotification from "helpers/notify";
import {
  findRowForRecord,
  recordFromClick,
  generateRawMeshes,
  generateRawTree,
} from "helpers/three";
import { useHttpWithCache } from "hooks/useHtthWithCache";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import TreeViewMenu from "react-simple-tree-menu";
import { expandKeysForPath, scrollTargetId, findClickedMesh } from "helpers/treePathKeys";
import { scrollRowToCentre } from "helpers/scrollRowToCentre";
import { reportClientError } from "helpers/clientLog";
import ResizablePanels from "resizable-panels-react";
import WebGlApp from "webgl";
import NoMeshModal from "../../components/NoMeshModal";
import { useHttp } from "../../hooks/useHttp";

import { useLogout } from "hooks/useLogout";
import "../ModelViewer/TimelineViewer.scss";

import { ReactComponent as CloseIcon } from "../../assets/images/down-arrow.svg";

import estimationImg from "assets/images/estimationImg.png";
import projectIcon from "assets/images/projectIcon.png";

import ModelResizableViewer from "components/hoc/resizable-viewer/modelResizable-viewer";
import { QuantityContext } from "../../hooks/quantityContext";
import Filters from "components/Share/Filters";
import useProjectFiles from "hooks/useProjectFiles";
import ViewerEffectsButton from "components/Viewer/ViewerEffectsButton";
import ViewerViewButtons from "components/Viewer/ViewerViewButtons";
import ViewerToolbar from "components/Viewer/ViewerToolbar";
import { scopeTreeIds } from "helpers/stableNodeId";
import { attachBuildingGrid } from "helpers/buildingGridLoad";

const Viewer3d = (props) => {
  const { projectId, token, line } = props;
  const dispatch = useDispatch();
  const logOut = useLogout();
  const viewerRef = useRef();
  const WebGL = useRef();
  const history = useHistory();
  const resizeRef = useRef();
  const [currencysymb, setCurrencysymb] = useState("");
  const projectsRedux = useSelector((s) => s.user.projects);
  const usersRedux = useSelector((s) => s.user.users);
  const selectedMesh = useRef(null);
  // WHAT A 3D CLICK CAN ACTUALLY SEE (owner, 2026-10-20: the Project Files
  // tree still did not expand after two attempts at this).
  //
  // The viewer stores these callbacks ONCE - webgl/js/viewer/index.js:509,
  // `this.ReactApi = ReactAPI` - so every click calls the copy of
  // findInJsonUsingViewer that existed when the viewer was created. That
  // closure captured filesMeshesArray and treeFilesData AS THEY WERE AT MOUNT:
  // null and []. Reading state inside it therefore reads the empty values
  // forever, which is why the previous fix changed nothing anyone could see.
  //
  // A ref is one mutable box the frozen closure can still look inside, which
  // is the only shape that works against a captured callback. Kept in step
  // with the state by the effect below rather than assigned mid-render.
  const filesMeshesRef = useRef(null);
  const treeFilesRef = useRef([]);

  // The list row is slim; the model's file lists come with the project
  // itself (hooks/useProjectFiles).
  const listProject = Maybe.of(projectsRedux).map((projects) => {
    return projects.filter((project) => project._id == projectId)[0];
  }).value;
  const project = useProjectFiles(projectId, listProject);

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && project && !isGLOpend) {
      setGLOpend(true);
      initializeAPI();
    }
    return () => (isMountedRef.current = false);
  }, [project]);

  const isMountedRef = useRef(null);

  const [clickedChild, setClickedChild] = useState([]);
  const [percentsLoaded, setPercentsLoaded] = useState(0);
  const [allowToResize, setAllowToResize] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [modal, setModal] = useState(false);
  const [isPopover, setIsPopOver] = useState(false);
  const [popoverCoords, setCoordsForPopover] = useState({
    top: "0px",
    left: "0px",
  });
  //
  const [resize, setResize] = useState(null);
  const [isUnmatchedMeshes, setIsUnmatchedMeshes] = useState(false);
  //
  const [isExistingMeshes, setIsExistingMeshes] = useState(false);
  const [isDemolitionMeshes, setIsDemolitionMeshes] = useState(false);
  //
  const [isSecondScreen, setSecondScreen] = useState(true);
  const [isFirstScreen, setFirstScreen] = useState(true);

  const [selectGroups, setSelectGroups] = useState([]);
  const [isGLOpend, setGLOpend] = useState(false);

  const [menu, setMenu] = useState(false);

  // project files variables
  let filesMeshes = [];
  let treeFilesMeshes = [];

  let additionalMeshes = [];
  let electricalMeshes = [];
  let mechanicalMeshes = [];
  let pipingMeshes = [];
  let switchMeshes = [];

  let [modelNumber, setModelNumber] = useState(0);
  let [modelsNames, setModelsNames] = useState([]);
  let [jsons, setJsons] = useState([]);
  let [models, setModels] = useState([]);
  let [additionalParams] = useState([]);
  let [electricalCircuits] = useState([]);
  let [mechanicalSystems] = useState([]);
  let [pipingSystems] = useState([]);
  let [switchSystems] = useState([]);
  const [scrollId, setScrollId] = useState("");

  const [treeFilesData, setTreeFilesData] = useState([]);
  const [filesOpenNodes, setFilesOpenNodes] = useState([]);
  const [filesMeshesArray, setFilesMeshes] = useState(null);

  const [additionalMeshesArray, setAdditionalMeshes] = useState(null);
  const [electricalMeshesArray, setElectricalMeshes] = useState(null);
  const [mechanicalMeshesArray, setMechanicalMeshes] = useState(null);
  const [pipingMeshesArray, setPipingMeshes] = useState(null);
  const [switchMeshesArray, setSwitchMeshes] = useState(null);

  const [isFilesMeshes, setIsFilesMeshes] = useState(false);
  const [clickedFilesChild, setClickedFilesChild] = useState([]);

  const [FiltersArr, setFiltersArr] = useState([]);
  const [additionalData, setAdditionalData] = useState([]);

  const meshQuantityInfoRef = useRef([]);

  let FilesMeshesForFilters = [];

  useEffect(() => {
    const filtersPayload = [
      { ProjectFiles: treeFilesData.filter((item) => item) },
      { UnpricedComponents: [] },
      { ExistingComponents: [] },
      { DemolitionComponents: [] },
      { PricedComponents: [] },
      { AdditionalParams: additionalData.filter((item) => item) },
    ];
    if (electricalMeshesArray) {
      filtersPayload.push({ ElectricalCircuits: electricalMeshesArray });
    }
    if (mechanicalMeshesArray) {
      filtersPayload.push({ MechanicalSystems: mechanicalMeshesArray });
    }
    if (pipingMeshesArray) {
      filtersPayload.push({ PipingSystems: pipingMeshesArray });
    }
    if (switchMeshesArray) {
      filtersPayload.push({ SwitchSystems: switchMeshesArray });
    }
    setFiltersArr(filtersPayload);
  }, [
    treeFilesData,
    additionalData,
    electricalMeshesArray,
    mechanicalMeshesArray,
    pipingMeshesArray,
    switchMeshesArray,
  ]);

  useEffect(() => {
    if (menu) {
      resizeRef.current.state.panelsSize = [100];
    } else {
      resizeRef.current.state.panelsSize = [0];
    }
  }, [menu]);

  const { request: initializeAPI } = useHttp({
    requestCallback: async (d) => {
      const obj1 = project?.zipInfo?.pathsmapping?.forEach((fname) => {
        if (fname.endsWith(".json") || fname.endsWith(".json.gz")) {
          setModelNumber(modelNumber);
          modelNumber = modelNumber + 1;
          var fileName = fname.split(".")[0];
          modelsNames.push(fileName);
          setModelsNames(modelsNames);
        }
      });

      var baseURL = url;
      if (project?.isIfcProject) {
        baseURL = project.isIfcProject ? IFC_Url : url;
      }
      const obj2 = project?.zipInfo?.paths?.forEach((path, i) => {
        const filename = project?.zipInfo?.pathsmapping[i];
        if (filename?.includes("_AdditionalParam")) {
          additionalParams.push(`${path}`);
        }
        if (filename?.includes("_ElectricalCircuits")) {
          electricalCircuits.push(`${path}`);
        }
        if (filename?.includes("_MechanicalSystems")) {
          mechanicalSystems.push(`${path}`);
        }
        if (filename?.includes("_PipingSystems")) {
          pipingSystems.push(`${path}`);
        }
        if (filename?.includes("_SwitchSystems")) {
          switchSystems.push(`${path}`);
        }
        if (path.endsWith(".glb") || path.endsWith(".glb.gz")) {
          models.push(`${baseURL}/${path}`);
        } else if (path.endsWith(".json") || path.endsWith(".json.gz")) {
          jsons.push(`${path}`);
        }
      });

      setModels(models);
      setJsons(jsons);
      for (let i = 0; i < modelNumber; i++) {
        var mNumber = i;
        var mpath = jsons[i];
        var mAdditionalPath = additionalParams[i];
        var mElectricalCircuitsPath = electricalCircuits[i];
        var mMechanicalSystemsPath = mechanicalSystems[i];
        var mPipingSystemsPath = pipingSystems[i];
        var mSwitchSystemsPath = switchSystems[i];

        // download raw json
        await getCompressedJsonFile(
          mpath,
          project?.isIfcProject ? project?.isIfcProject : false
        )
          .then((res) => {
            filesMeshes[mNumber] = generateRawMeshes(res); //generateMeshes(res);
            // Per-file scope: each file's $id restarts at "1" (helpers/stableNodeId).
            treeFilesMeshes[mNumber] = scopeTreeIds(generateRawTree(res), `${projectId}:${mNumber}`);
          })
          .catch((err) => {});

        // download additional json
        await getCompressedJsonFile(
          mAdditionalPath,
          project?.isIfcProject ? project?.isIfcProject : false
        )
          .then((res) => {
            additionalMeshes[mNumber] = res;
          })
          .catch((err) => {});

        // download electrical json
        await getCompressedJsonFile(
          mElectricalCircuitsPath,
          project?.isIfcProject ? project?.isIfcProject : false
        )
          .then((res) => {
            electricalMeshes[mNumber] = res;
          })
          .catch((err) => {});

        // download mechanical json
        await getCompressedJsonFile(
          mMechanicalSystemsPath,
          project?.isIfcProject ? project?.isIfcProject : false
        )
          .then((res) => {
            mechanicalMeshes[mNumber] = res;
          })
          .catch((err) => {});

        if (mPipingSystemsPath) {
          await getCompressedJsonFile(
            mPipingSystemsPath,
            project?.isIfcProject ? project?.isIfcProject : false
          )
            .then((res) => {
              pipingMeshes[mNumber] = res;
            })
            .catch((err) => {});
        }

        if (mSwitchSystemsPath) {
          await getCompressedJsonFile(
            mSwitchSystemsPath,
            project?.isIfcProject ? project?.isIfcProject : false
          )
            .then((res) => {
              switchMeshes[mNumber] = res;
            })
            .catch((err) => {});
        }
      }

      // The live version's own manifest (helpers/liveManifest), not the
      // project-level copy a promote rewrites.
      const manifestUrl = baseURL === url ? await liveManifestUrl(projectId) : legacyManifestUrl(baseURL, projectId);
      WebGL.current = new WebGlApp(
        viewerRef.current,
        {
          glbs: models,
          // NEW: streaming activates when a manifest exists for this
          // project. URL hits the same /uploads/ route the legacy GLB
          // pipeline uses — the existing Express route in back/app.js
          // handles signed R2 redirects. StreamingLoader falls back to
          // the legacy Loader (using `glbs`) automatically when the
          // manifest 404s, so this is safe to add unconditionally.
          //
          // baseURL was computed earlier in this same function (defaults
          // to `url`, switches to IFC_Url for IFC projects). projectId
          // is a destructured prop from the component.
          manifestUrl,
        },
        {
          setClickedChild,
          setLoading,
          setError,
          setPercentsLoaded,
          setAllowToResize,
          setModal,
          setCoordsForPopover,
          findInJsonUsingViewer,
          setIsPopOver,
          onHoverMesh,
          selectedMesh,
          project,
        },
        line,
        false,
        project?.isIfcProject ? project?.isIfcProject : false
      );
      attachBuildingGrid(WebGL.current.viewer, projectId);
    },
    onLoad: (res) => {
      setFilesMeshes([...filesMeshes]);
      setAdditionalMeshes(...additionalMeshes);
      setElectricalMeshes(...electricalMeshes);
      setMechanicalMeshes(...mechanicalMeshes);
      if (pipingMeshes.length > 0) setPipingMeshes(...pipingMeshes);
      if (switchMeshes.length > 0) setSwitchMeshes(...switchMeshes);

      setTreeFilesData([...treeFilesMeshes]?.filter((item) => item));
      setFilesOpenNodes([
        ...filesOpenNodes,
        ...[...treeFilesMeshes]?.filter((item) => item).map((tv) => tv[0]?.key),
      ]);

      setAdditionalData(FilesMeshesForFilters);
    },
    onError: (e) => {
      console.error(e);
      setError(true);
    },
  });

  const {
    error: cacheError,
    loading: cacheLoading,
    errorStatus: cacheErrorStatus,
    request: cacheRequest,
    refresh,
  } = useHttpWithCache({
    requestCallback: () => getProjects(),
    reduxSetter: (data) => {
      dispatch(setProjects(data.projects));
      dispatch(setCompanyUsers(data.users));
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects: projectsRedux,
      users: usersRedux,
    },
    allowToCash: true,
  });

  const onHoverMesh = (id) => {};

  const jsonInfo = Maybe.of(
    (() => {
      if (true) {
        return {
          neededMeshesArray: filesMeshesArray,
          neededClickedChild: clickedFilesChild,
        };
      }
    })()
  ).map(({ neededMeshesArray, neededClickedChild }) => {
    meshQuantityInfoRef.current = neededClickedChild;
    return neededClickedChild.length === 1
      ? neededClickedChild?.flatMap((i) => {
          return neededMeshesArray
            ?.flat()
            ?.find((k) => k?.UniqueId === i?.UniqueId);
        })[0]
      : neededClickedChild.reduce(
          (totalObject, mesh) => {
            const sumProps = Object.assign(
              {},
              {
                LaborInfoTime:
                  totalObject.LaborInfoTime + mesh.LaborInfo
                    ? mesh.LaborInfo?.map((l) => l.TotalTime)
                    : 0,
                EquipmentInfoTime:
                  totalObject.EquipmentInfoTime + mesh.EquipmentInfo
                    ? mesh.EquipmentInfo?.map((l) => l.TotalTime)
                    : 0,

                LaborInfoPrice:
                  totalObject.LaborInfoPrice + mesh.LaborInfo
                    ? mesh.LaborInfo?.map((l) => l.TotalPrice)
                    : 0,
                EquipmentInfoPrice:
                  totalObject.EquipmentInfoPrice + mesh.EquipmentInfo
                    ? mesh.EquipmentInfo?.map((l) => l.TotalPrice)
                    : 0,

                Area: totalObject.Area + mesh.Area,
                Count: totalObject.Count + mesh.Count,
                Length: totalObject.Length + mesh.Length,
                Quantity: totalObject.Quantity + mesh.Quantity,
                Volume: totalObject.Volume + mesh.Volume,
                TotalPrice: totalObject.TotalPrice + mesh.TotalPrice,
              },
              typeof totalObject.Width === "number"
                ? {
                    Width: totalObject.Width + mesh.Width,
                  }
                : {},
              typeof totalObject.Depth === "number"
                ? {
                    Depth: totalObject.Depth + mesh.Depth,
                  }
                : {},
              typeof totalObject.TotalAmount === "number"
                ? {
                    TotalAmount: totalObject.TotalAmount + mesh.TotalAmount,
                  }
                : {},
              typeof totalObject.Dimentions === "number"
                ? {
                    Dimentions: totalObject.Dimentions + mesh.Dimentions,
                  }
                : {}
            );

            const stringProps = Object.assign(
              {},
              totalObject.Uniformat === mesh.Uniformat && totalObject.Uniformat
                ? { Uniformat: "-" }
                : { Uniformat: mesh.Uniformat },
              totalObject.Name !== mesh.Name && totalObject.Name
                ? { Name: "-" }
                : { Name: mesh.Name },
              totalObject.Type !== mesh.Type && totalObject.Type
                ? { Type: "-" }
                : { Type: mesh.Type },
              totalObject.MainCategory !== mesh.MainCategory &&
                totalObject.MainCategory
                ? { MainCategory: "-" }
                : { MainCategory: mesh.MainCategory },
              totalObject.CategoryName !== mesh.CategoryName &&
                totalObject.CategoryName
                ? { CategoryName: "-" }
                : { CategoryName: mesh.CategoryName },
              totalObject.LaborInfo !== mesh.LaborInfo && totalObject.LaborInfo
                ? { LaborInfoType: "-" }
                : {
                    LaborInfoType: mesh.LaborInfo
                      ? mesh.LaborInfo?.map((l) => l.Description).join(" | ")
                      : "-",
                  },
              totalObject.EquipmentInfo !== mesh.EquipmentInfo &&
                totalObject.EquipmentInfo
                ? { EquipmentInfoType: "-" }
                : {
                    EquipmentInfoType: mesh.EquipmentInfo
                      ? mesh.EquipmentInfo?.map((l) => l.Description).join(
                          " | "
                        )
                      : "-",
                  }
            );

            if (!totalObject.LaborInfo || totalObject.LaborInfo == null) {
              totalObject.LaborInfo = [];
            }
            totalObject.LaborInfo.push(
              ...totalObject.LaborInfo,
              mesh.LaborInfo ? mesh.LaborInfo : null
            );

            if (
              !totalObject.EquipmentInfo ||
              totalObject.EquipmentInfo == null
            ) {
              totalObject.EquipmentInfo = [];
            }
            totalObject.EquipmentInfo.push(
              ...totalObject.EquipmentInfo,
              mesh.EquipmentInfo ? mesh.EquipmentInfo : null
            );

            if (!totalObject.MaterialInfo || totalObject.MaterialInfo == null) {
              totalObject.MaterialInfo = [];
            }

            totalObject.MaterialInfo.push(...totalObject.MaterialInfo, {
              Types: mesh.MaterialNames,
              Name: mesh.Type,
              TotalAmount: mesh.TotalAmount,
              TotalPrice: mesh.TotalPrice,
            });

            return { ...sumProps, ...stringProps };
          },
          neededClickedChild[0]
            ? {
                ...neededClickedChild[0],
                ...{
                  LaborInfoTime: 0,
                  EquipmentInfoTime: 0,
                  EquipmentInfoPrice: 0,
                  LaborInfoPrice: 0,
                  LaborInfo: [],
                  EquipmentInfo: [],
                  MaterialInfo: [],
                  Area: 0,
                  Count: 0,
                  Length: 0,
                  Quantity: 0,
                  Volume: 0,
                  TotalPrice: 0,
                },
              }
            : null
        );
  }).value;

  const [additionalFileInfo, setAdditionalFileInfo] = useState(null);
  const [electricalFileInfo, setElectricalFileInfo] = useState(null);
  const [mechanicalFileInfo, setMechanicalFileInfo] = useState(null);

  useEffect(() => {
    (async () => {
      const additionalMatchedData = await Maybe.of(
        (() => {
          if (true) {
            return {
              neededMeshesArray: additionalMeshesArray,
              neededClickedChild: clickedFilesChild,
            };
          }
        })()
      ).map(({ neededMeshesArray, neededClickedChild }) => {
        return neededClickedChild?.map((i) => {
          return neededMeshesArray?.find((j) => {
            return j?.UniqueId === i?.UniqueId;
          });
        });
      }).value;

      const electricalMatchedData = await Maybe.of(
        (() => {
          return {
            neededMeshesArray: electricalMeshesArray,
          };
        })()
      ).map(({ neededMeshesArray }) => {
        return additionalMatchedData?.map((i) => {
          return neededMeshesArray?.find((j) => {
            return j?.uniqueId === i?.EquipmentParameters?.ElectricalSystem;
          });
        });
      }).value;

      const mechanicalmatchedData = Maybe.of(
        (() => {
          if (true) {
            return {
              neededMeshesArray: mechanicalMeshesArray,
            };
          }
        })()
      ).map(({ neededMeshesArray }) => {
        return additionalMatchedData?.map((i) => {
          return neededMeshesArray?.find((j) => {
            return j?.uniqueId === i?.EquipmentParameters?.MechanicalSystem;
          });
        });
      }).value;

      setAdditionalFileInfo(additionalMatchedData?.filter((item) => item));
      setElectricalFileInfo(
        electricalMatchedData.filter(function (element) {
          return element !== undefined;
        })
      );
      setMechanicalFileInfo(
        mechanicalmatchedData.filter(function (element) {
          return element !== undefined;
        })
      );
    })();
  }, [clickedFilesChild]);

  const jsonFilesMeshesToJSX = useMemo(() => {
    return treeFilesData.map((section, mainIndex) => {
      return Maybe.of(section).map((tree) => (
        <TreeViewMenu cacheSearch={false} key={`files-tree-${mainIndex}`} openNodes={filesOpenNodes} data={tree}>
          {({ items }) => {
            return items.map((item, index) => {
              return (
                <TreeViewerItem
                  item={item}
                  index={index}
                  clickedChild={clickedFilesChild}
                  setClickedChild={setClickedFilesChild}
                  selectGroups={selectGroups}
                  setSelectGroups={setSelectGroups}
                  // A uuid here remounts every ROW on every render, for the
                  // same reason the tree key did. The item's own key is
                  // stable and unique within its section.
                  key={item.key || item.id || index}
                  selectedMesh={selectedMesh}
                  WebGL={WebGL}
                  tree={tree}
                  setTreeData={(updatedSection) => {
                    [...treeFilesData][mainIndex] = updatedSection;
                    setTreeFilesData([...treeFilesData]);
                  }}
                  setOpenNodes={setFilesOpenNodes}
                  isUnmatchedMeshes={() => setIsUnmatchedMeshes(false)}
                  isExistingMeshes={() => setIsExistingMeshes(false)}
                  isDemolitionMeshes={() => setIsDemolitionMeshes(false)}
                  isFilesMeshes={() => setIsFilesMeshes(true)}
                  selectors={{
                    prevMeshes: "prevFilesMeshes",
                    prevMaterials: "prevFilesMaterials",
                    color: "green",
                  }}
                />
              );
            });
          }}
        </TreeViewMenu>
      )).value;
    });
    // THE DEPENDENCY WAS `[...treeFilesData]` - a NEW ARRAY ON EVERY RENDER, so
    // this memo never held and the tree was rebuilt constantly. The array
    // identity is what changes when the data changes, so depend on it.
  }, [treeFilesData, clickedFilesChild, filesOpenNodes]);

  const pickMeshInNeededTree = (
    clicked,
    treeMeshes,
    setOpenNodes,
    setClickedChild,
    keyIsCtrl,
    selectors
  ) => {
    setSelectGroups([]);
    if (!clicked) {
      setModal(true);
    } else {
      // ONE ENTRY PER DOCUMENT, or one bare record: helpers/three
      // recordFromClick decides, so neither shape can throw or go missing.
      const newClicked = recordFromClick(clicked);

      let path;

      // ONE CALL, EVERY TREE SHAPE (owner, 2026-10-21: "pull the code from
      // all other viewers and fix same issue"). The two branches below asked
      // for node.id === $id, which is a JSON.NET reference number: a node
      // built without one carries a derived id and the search matched
      // nothing - no expansion, no highlight, no scroll. findRowForRecord
      // asks by the leaf id we inserted, then Revit's UniqueId, then $id,
      // searches every root rather than the first, and takes the trees as a
      // list instead of being handed one where the id belonged.
      path = findRowForRecord(treeMeshes, newClicked).path;

      clicked = newClicked;

      console.log("path from pick needed mesh ", path);

      // EVERY ANCESTOR, NOT FOUR OF THEM. This built exactly four keys -
      // path[0] through path[3] - which matched the file tree's shape
      // (root > category > group > component) and nothing else: a shallower
      // path threw on path[3].id and expanded nothing at all, a deeper one
      // left the element's own branch shut. react-simple-tree-menu keys a node
      // by its ancestors joined with "/", so the keys are built by walking.
      const nodesKey = expandKeysForPath(path);
      if (!nodesKey.length) {
        console.warn("[viewer] no tree path for the clicked element - nothing to expand");
        return;
      }
      nodesKey.forEach((nodeKey) => {
        setOpenNodes((s) => {
          if (s?.includes(nodeKey)) {
            return s;
          }
          return [...s, nodeKey];
        });
      });
      setClickedChild((s) => {
        if (keyIsCtrl) {
          if (s.find((mesh) => mesh.UniqueId === clicked.UniqueId)) {
            const neededIndex = s.findIndex(
              (mesh) => mesh.UniqueId === clicked.UniqueId
            );
            return [...s.slice(0, neededIndex), ...s.slice(neededIndex + 1)];
          }
          return [...s, clicked];
        } else {
          return [clicked];
        }
      });
      setScrollId(scrollTargetId(path));   // the clicked node itself, however deep

      WebGL.current.viewer.onClickChildInList(
        clicked ? clicked.UniqueId : "",
        keyIsCtrl,
        selectors,
        false,
        false // shouldFrameCamera
      );
      selectedMesh.current = clicked.UniqueId;
    }
  };

  const findInJsonUsingViewer = (id, keyIsCtrl) => {
    // Project files
    // READ THE STATE, NOT THE PER-RENDER LOCALS (owner, 2026-10-20: "project
    // files tree items don't get auto expanded and selected when we select 3D
    // item").
    //
    // `filesMeshes` and `treeFilesMeshes` are declared `let ... = []` in the
    // component body, so React RESETS THEM TO EMPTY ON EVERY RENDER. They are
    // filled while the JSON downloads and copied into state at onLoad
    // (setFilesMeshes / setTreeFilesData); from the next render onward the raw
    // arrays are [] again. This handler runs on a click - always a later
    // render - so it was searching two empty arrays and could never find the
    // element, whatever the ids were.
    //
    // THE IDS WERE NEVER THE PROBLEM, which is worth writing down because it
    // is the obvious suspect: generateRawMeshes and generateRawTree are built
    // from the SAME parsed JSON, so a mesh's UniqueId (what a 3D click
    // carries) and its $id (what a tree node keys on) belong to one object -
    // the tree node's `meshInfo` IS the mesh. The hop
    // UniqueId -> mesh -> $id -> tree node is sound.
    const loadedFiles = Array.isArray(filesMeshesRef.current) ? filesMeshesRef.current : [];
    const loadedTrees = treeFilesRef.current || [];
    const { perFile: clickedFilesMesh, found } = findClickedMesh(loadedFiles, id);

    // `.map` returns one entry per file, undefined where the file does not
    // hold this element - and an array is truthy even when every entry is
    // undefined, so `if (clickedFilesMesh)` used to be true for EVERY click,
    // including elements belonging to the Existing, Demolition or Unmatched
    // trees.
    if (!found || !loadedTrees.length) {
      // SAY SO. Returning in silence is what made this look like a dead
      // click for weeks: nothing moved and nothing explained why.
      console.warn(
        "[viewer] no Project Files row for the clicked element",
        { uniqueId: id, filesLoaded: loadedFiles.length, treesLoaded: loadedTrees.length },
      );
      return;
    }
    {
      setIsFilesMeshes(true);
      setIsDemolitionMeshes(false);
      setIsExistingMeshes(false);
      setIsUnmatchedMeshes(false);
      pickMeshInNeededTree(
        clickedFilesMesh,
        loadedTrees,
        setFilesOpenNodes,
        setClickedFilesChild,
        keyIsCtrl,
        {
          prevMeshes: "prevFilesMeshes",
          prevMaterials: "prevFilesMaterials",
          color: "green",
        }
      );
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (!projectsRedux && !line) {
      if (isMountedRef.current) {
        cacheRequest();
      }
    }
    return () => (isMountedRef.current = false);
  }, [projectsRedux]);

  // The refs follow the state. An effect, not an assignment during render:
  // the handler is only ever called from a click, so it never needs a value
  // that this render has not committed yet.
  useEffect(() => {
    filesMeshesRef.current = filesMeshesArray;
  }, [filesMeshesArray]);

  useEffect(() => {
    treeFilesRef.current = (treeFilesData || []).filter((t) => t);
  }, [treeFilesData]);

  useEffect(() => {
    isMountedRef.current = true;
    // ONE SHARED SCROLL, CONVERGENT (owner, 2026-10-21: "check that every
    // other viewer is also working correctly", then "do both").
    //
    // This looked for the row ONCE - so a row drawn by the render the click
    // triggers was simply missed - and then used scrollIntoView with
    // behavior "smooth" and block "nearest". On the model viewer that pair
    // measurably did nothing: smooth over 100,000px is asynchronous and
    // unreliable at that distance, and "nearest" is a no-op for a row already
    // judged near. Aiming once was wrong too - the layout moves as the render
    // commits, measured 7,000px out four times in five.
    //
    // scrollRowToCentre waits for the row, finds the ancestor that actually
    // scrolls, positions it directly and then corrects until the row stays
    // centred. Same code as the model viewer now, rather than this page's own
    // version of it.
    const cancel = scrollRowToCentre(scrollId, {
      isAlive: () => isMountedRef.current,
      report: (r) => reportClientError("viewer3d/scroll", { message: JSON.stringify(r) }),
    });
    return () => { cancel(); isMountedRef.current = false; };
  }, [scrollId]);

  useEffect(() => {
    if (cacheErrorStatus) {
      const stringError = String(cacheErrorStatus);
      addNotification(stringError, "danger");
      if (stringError.toLowerCase()?.includes("unexpected token")) {
        logOut();
        history.push("/");
      }
    }
  }, [cacheErrorStatus]);

  const infoPanel = (
    <div
      style={{
        minWidth: `${isSecondScreen ? resize?.panels[1] || 600 : ""}px`,
        maxWidth: `${isSecondScreen ? resize?.panels[1] || 600 : ""}px`,
      }}
      className="viewer-outer-div"
    >
      <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
        <div className="d-flex align-items-center viewer-header-item ">
          <img src={estimationImg} className="estimation-icon" />
          Component Details:
        </div>

        <MDBBox
          onClick={() => setSecondScreen((s) => !s)}
          className={`viewer-icon ${
            !isSecondScreen ? "viewer-icon-rotate" : ""
          }`}
        >
          <CloseIcon />
        </MDBBox>
      </div>
    </div>
  );

  const ProjectPanel = (
    <div
      style={{
        minWidth: `${isFirstScreen ? resize?.panels[2] || 600 : ""}px`,
        maxWidth: `${isFirstScreen ? resize?.panels[2] || 600 : ""}px`,
      }}
      className="viewer-outer-div"
    >
      <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
        <MDBBox className="viewer-header-item d-flex align-items-center">
          <img src={projectIcon} className="project-icon" />
          Project Files
        </MDBBox>
        <MDBBox
          onClick={() => setFirstScreen((s) => !s)}
          className={`viewer-icon ${
            !isFirstScreen ? "viewer-icon-rotate" : ""
          }`}
        >
          <CloseIcon />
        </MDBBox>
      </div>
    </div>
  );

  return (
    <div className="timeline-viewer-container mt-2">
      <MDBBox className="viewer d-flex overflow-hidden flex-wrap">
        <MDBBox className="viewer-header viewer-header1 d-flex w-100">
          {isFirstScreen && isSecondScreen && (
            <>
              {ProjectPanel}
              {infoPanel}
            </>
          )}

          {!isFirstScreen && isSecondScreen && (
            <>
              {infoPanel}
              {ProjectPanel}
            </>
          )}
          {isFirstScreen && !isSecondScreen && (
            <>
              {ProjectPanel}
              {infoPanel}
            </>
          )}

          {!isFirstScreen && !isSecondScreen && (
            <>
              {ProjectPanel}
              {infoPanel}
            </>
          )}

          <div className="d-flex align-items-center justify-content-end flex-grow-1 px-2 viewer-header-item viewer-gapping h-100">
            {project ? (
              <MDBBox tag="span" className="viewer-header-item">
                <div className="d-flex align-items-center project-admin-header ">
                  <i className="fa fa-home mr-2"></i> Project:
                  <strong className="ml-2">{project.title}</strong>
                </div>
              </MDBBox>
            ) : null}
            {/* <button
              className="bg-bid header-btn text-white ml-2 font-weight-light"
              onClick={() => setMenu(!menu)}
            >
              {" "}
              <i className="fa fa-filter mr-2" />
              Filters
            </button> */}
          </div>
        </MDBBox>

        {/* resizable main container starts */}
        <ModelResizableViewer
          width="100%"
          height="100%"
          WebGlApp={WebGL.current}
          setResize={setResize}
          isFirstScreen={isFirstScreen}
          isSecondScreen={isSecondScreen}
          allowToResize={allowToResize}
        >
          {/* project files container starts */}
          <div style={{ height: "100%" }}>
            <ResizablePanels
              displayDirection="column"
              width="100%"
              maxheight="100%"
              panelsSize={0}
              resizerSize="3px"
              sizeUnitMeasure="%"
            >
              <MDBBox className="overflow-auto h-76vh inner_resizable">
                {jsonFilesMeshesToJSX}
                {loading ? (
                  <MDBBox className="h-100">
                    <Loading color="black" text="Loading components..." />
                  </MDBBox>
                ) : null}
              </MDBBox>
              <MDBBox></MDBBox>
            </ResizablePanels>
          </div>

          {/* estimation-info container starts */}
          <MDBBox className="overflow-auto h-76vh inner_resizable">
            <MDBListGroup>
              {console.log(jsonInfo)}
              {jsonInfo &&
                Object.entries(jsonInfo).map((keyAndValue) => {
                  const [key, value] = keyAndValue;
                  if (key === "$id") {
                    return null;
                  }

                  if (key === "TotalPrice" || key === "UnitPrice") {
                    return null;
                  }

                  return (
                    <MDBListGroupItem
                      key={key}
                      className="border border-light py-1 text-truncate"
                    >
                      {`${key}: ${value}`}
                    </MDBListGroupItem>
                  );
                })}
            </MDBListGroup>

            {/* Additional-info container starts */}
            {additionalFileInfo?.length === 1 && (
              <>
                <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
                  <div className="d-flex align-items-center viewer-header-item ">
                    <img src={estimationImg} className="estimation-icon" />
                    Additional Details:
                  </div>
                </div>

                <MDBListGroup>
                  <MDBListGroupItem className="border border-light py-1 text-truncate">
                    {`Name: ${additionalFileInfo[0]?.Name}`}
                  </MDBListGroupItem>

                  {Object.entries(
                    additionalFileInfo[0]?.BuiltInParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}

                  {Object.entries(
                    additionalFileInfo[0]?.EquipmentParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}

                  {Object.entries(
                    additionalFileInfo[0]?.FamilyParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}

                  {Object.entries(
                    additionalFileInfo[0]?.GlobalParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}

                  {Object.entries(
                    additionalFileInfo[0]?.ProjectParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}

                  {Object.entries(
                    additionalFileInfo[0]?.SharedParameters || {}
                  )?.map((keyandvalue) => {
                    const [key, value] = keyandvalue;
                    return (
                      <MDBListGroupItem
                        className="border border-light py-1 text-truncate"
                        key={key}
                      >
                        {`${key}: ${value}`}
                      </MDBListGroupItem>
                    );
                  })}
                </MDBListGroup>
              </>
            )}

            {/* Electrical-info container starts */}
            {electricalFileInfo?.length === 1 && (
              <>
                <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
                  <div className="d-flex align-items-center viewer-header-item ">
                    <img src={estimationImg} className="estimation-icon" />
                    Electrical Systems:
                  </div>
                </div>

                <MDBListGroup>
                  {electricalFileInfo?.map((item) => {
                    return Object.entries(item).map((keyAndValue) => {
                      const [key, value] = keyAndValue;
                      return (
                        <MDBListGroupItem
                          key={key}
                          className="border border-light py-1 text-truncate"
                        >
                          {`${key}: ${value}`}
                        </MDBListGroupItem>
                      );
                    });
                  })}
                </MDBListGroup>
              </>
            )}

            {/* Mechanical-info container starts */}
            {mechanicalFileInfo?.length === 1 && (
              <>
                <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
                  <div className="d-flex align-items-center viewer-header-item ">
                    <img src={estimationImg} className="estimation-icon" />
                    Mechanical Systems:
                  </div>
                </div>
                <MDBListGroup>
                  {mechanicalFileInfo?.map((item) => {
                    return Object.entries(item).map((keyAndValue) => {
                      const [key, value] = keyAndValue;
                      return (
                        <MDBListGroupItem
                          key={key}
                          className="border border-light py-1 text-truncate"
                        >
                          {`${key}: ${value}`}
                        </MDBListGroupItem>
                      );
                    });
                  })}
                </MDBListGroup>
              </>
            )}
          </MDBBox>

          {/* 3d modal and share container starts */}
          <div className="h-100 position-relative">
            <ResizablePanels
              displayDirection="column"
              width="100%"
              height="100%"
              panelsSize={[0, 100]}
              resizerSize={menu ? "10px" : "0px"}
              resizerColor="#E6EAF4"
              sizeUnitMeasure="%"
              ref={resizeRef}
            >
              <QuantityContext.Provider
                value={{
                  Currency: currencysymb,
                  meshQuantityInfoRef: meshQuantityInfoRef.current,
                }}
              >
                <div className="share-container-new">
                  <div
                    className="share-wrappre"
                    style={menu ? {} : { display: "none" }}
                  >
                    <div className="share">
                      {/* Filters takes setTreeData and treeData. This mount
                          passed setTreeFilesData and no treeData, so Apply and
                          Reset would throw if this panel were ever opened - its
                          button is commented out above, so it never has been.
                          Wired the way Share.jsx does it rather than left as a
                          trap for whoever uncomments that button. */}
                      <Filters
                        FiltersData={FiltersArr}
                        setTreeData={setTreeFilesData}
                        treeData={treeFilesData}
                        WebGL={WebGL}
                      />
                    </div>
                  </div>
                </div>
              </QuantityContext.Provider>

              <div
                id="WebglViewer"
                style={{ flexGrow: 1 }}
                className="h-100 position-relative"
                ref={viewerRef}
              >
                {loading ? (
                  <MDBBox className="h-100 w-100 flex-center flex-column">
                    <Loading color="black" text="Loading model..." />
                    {percentsLoaded ? (
                      <span>{percentsLoaded}% has loaded...</span>
                    ) : null}
                  </MDBBox>
                ) : null}
                {/* TOP RIGHT, the same corner on every page (owner,
                    2026-09-20). It was mounted inside the .viewer-zoom
                    group below - `bottom: 56px`, no left or right - so it
                    inherited that group's BOTTOM-LEFT corner. Its own
                    positioned box makes the corner a property of the strip
                    rather than of whatever it was dropped into.
                    #WebglViewer is position-relative; these offsets are
                    measured from it. */}
                <div
                  className="position-absolute"
                  style={{ top: 12, right: 12, zIndex: 5 }}
                >
                  <ViewerViewButtons
                    viewer={() => WebGL.current && WebGL.current.viewer}
                    variant="mdb"
                  />
                </div>
                {/* THE shared toolbar (components/Viewer/ViewerToolbar) - the model
                    view's own icons and placement, on every 3D page (owner,
                    2026-09-23). This page used to hand-write the same ten
                    buttons and the same four ids. The buttons below are the
                    ones that really are this page's. */}
                {/* A CORNER OF ITS OWN. `viewer-zoom` only carries coordinates in
                    the model-view and timeline stylesheets; on this page the class
                    is inert, so without a positioned wrapper the toolbar sits
                    wherever it falls in flow (Mark measured x=-41 on tracking,
                    lying across twenty controls). */}
                <div style={{ position: "absolute", left: 12, right: 12, bottom: 12, zIndex: 5,
                   display: "flex", justifyContent: "flex-end", pointerEvents: "none" }}>
                  <ViewerToolbar viewer={() => WebGL.current && WebGL.current.viewer}>
                <MDBBtn
                    id="enableDisableElementsBtn"
                    title="Enable/Disable Elements — toggle visibility of components in the Disabled tree"
                    size="sm"
                    color=""
                    className="bg-white modal3d-tool-btn"
                    onClick={(e) => {
                      const willShow = !e.currentTarget.classList.contains('buttonEnabled');
                      e.currentTarget.classList.toggle('buttonEnabled');
                      try {
                        const store = WebGL.current?.viewer?.streaming?.state;
                        const enumerator = WebGL.current?.viewer?.streaming?.enumerateDisabledUids;
                        if (store && enumerator) {
                          const uids = enumerator();
                          uids.forEach(uid => {
                            if (willShow) store.showDisabled(uid);
                            else store.hideDisabled(uid);
                          });
                        }
                      } catch (err) {
                        console.warn('[EnableDisable] apply failed:', err);
                      }
                    }}
                  >
                    <MDBIcon icon="power-off" className="font-size-1" />
                  </MDBBtn>
                </ViewerToolbar>
                </div>
              </div>
            </ResizablePanels>
          </div>
        </ModelResizableViewer>

        <NoMeshModal isOpen={modal} toggle={() => setModal((s) => !s)} />
      </MDBBox>
    </div>
  );
};

export default Viewer3d;